import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mockData';
import '../styles/testimonials.css';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const nextTestimonial = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="testimonials-header">
          <div className="section-label">
            <span>Success Stories</span>
          </div>
          <h2 className="section-title">
            Hear from Our <span className="text-highlight">Champions</span>
          </h2>
        </div>

        <div className="testimonials-wrapper">
          <button className="testimonial-nav prev" onClick={prevTestimonial}>
            <ChevronLeft size={24} />
          </button>

          <div className="testimonial-content">
            <div className="quote-icon">
              <Quote size={48} />
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} fill="#FF6B35" color="#FF6B35" />
                ))}
              </div>
              
              <p className="testimonial-text">{currentTestimonial.text}</p>
              
              <div className="testimonial-author">
                <img
                  src={currentTestimonial.image}
                  alt={currentTestimonial.name}
                  className="author-image"
                />
                <div className="author-info">
                  <div className="author-name">{currentTestimonial.name}</div>
                  <div className="author-role">{currentTestimonial.role}</div>
                </div>
              </div>
            </div>
          </div>

          <button className="testimonial-nav next" onClick={nextTestimonial}>
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToTestimonial(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
